import { ShortLanguage, FullLanguage } from '../../models/language';
import { LanguageByCode, LanguageByResource, LanguageList } from 'Shared/app/constants/languages.constants';

const toShortLanguage = (l: FullLanguage): ShortLanguage => ({
  code: l.code,
  text: l.careproviderName
});

export const getLanguageNames = (languageCodes: number[]): ShortLanguage[] => {
  const codeSet = new Set(languageCodes);
  return LanguageList.filter((l) => codeSet.has(l.code)).map(toShortLanguage);
};

export const getLanguageName = (languageCode: number): ShortLanguage | undefined => {
  const language = LanguageByCode.get(languageCode);
  return language
    ? { code: language.code, text: language.careproviderName }
    : undefined;
};

export const getLanguageObject = (languageCode: number): FullLanguage | undefined =>
  LanguageByCode.get(languageCode);

export const getLanguageObjectByResource = (languageResource: string): FullLanguage | undefined =>
  LanguageByResource.get(languageResource.toLowerCase());

export const getLanguageResources = (languageCodes: number[]): string[] => {
  const codeSet = new Set(languageCodes);
  return LanguageList.filter((l) => codeSet.has(l.code)).map((l) => l.resource);
};
